export const SKELETON_LOADER_CONSTANTS = {
    TABLE: {
        ROWS: 5,
        COLUMNS: 6,
        SHOW_HEADER: true,
        COLUMN_WIDTHS: ['12%', '15%', '18%', '20%', '15%', '20%'],
        HEADER_HEIGHT: '32px',
        ROW_HEIGHT: '40px',
    },
    PAYMENT_TABLE: {
        ROWS: 4,
        COLUMNS: 5,
    },
} as const
